module.exports = __webpack_public_path__ + "img/public/AdminIcons/uploadCSV.svg?b7d4b0ec";